import React from "react";
import PortfolioProductInfo from "components/Product-Info-Pages/Portfolio/PortfolioProductInfo";

const Portfolio = () => <PortfolioProductInfo />;

export default Portfolio;
